// A slug out of a title, for the create form to offer — `Hello, World!` is
// `hello-world`. Lowercase ASCII letters and digits with single hyphens, which
// is exactly what /Blog/Slug admits; anything else is dropped rather than
// transliterated, so an author writing in another script gets an empty
// suggestion and types one, rather than a mangled one.
export const slugOf = (text) =>
  String(text || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 128)
    .replace(/-+$/, "");
